import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class WorksImportRequest extends GenericRequest {

    term;
    page;

    constructor(page, term = '') {
        super(METHOD_POST, ApiEndpoints.WORKS_IMPORT);

        this.page = page;
        this.term = term;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        request.criteria.term = '';
        if ( this.term ) request.criteria.term = this.term;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/works/ws/WorksImportRequest.js